var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppinstancesmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.648 37.944L23.2 32.52L32.648 27.056L42.064 32.52L32.648 37.944Z",
    fill: "url(#paint0_linear_3890_386374)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 18.496L32.616 13.104L41.968 18.496L32.616 23.952L23.2 18.496Z",
    fill: "url(#paint1_linear_3890_386374)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.616 23.952V34.728L41.968 29.336V18.496L32.616 23.952Z",
    fill: "url(#paint2_linear_3890_386374)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.616 23.952L23.2 18.496V29.336L32.616 34.728V23.952Z",
    fill: "url(#paint3_linear_3890_386374)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 18.496L32.616 23.952",
    stroke: "#DCDCDC",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.736 46.064L37.288 40.64L46.736 35.176L56.152 40.64L46.736 46.064Z",
    fill: "url(#paint4_linear_3890_386374)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.288 26.608L46.704 21.216L56.056 26.608L46.704 32.064L37.288 26.608Z",
    fill: "url(#paint5_linear_3890_386374)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.704 32.064V42.84L56.056 37.448V26.608L46.704 32.064Z",
    fill: "url(#paint6_linear_3890_386374)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.704 32.064L37.288 26.608V37.448L46.704 42.84V32.064Z",
    fill: "url(#paint7_linear_3890_386374)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37.392 26.672L46.704 32.064",
    stroke: "#DCDCDC",
    strokeWidth: 0.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6639 46.064L9.21594 40.64L18.6639 35.176L28.0799 40.64L18.6639 46.064Z",
    fill: "url(#paint8_linear_3890_386374)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21594 26.608L18.6319 21.216L27.9839 26.608L18.6319 32.064L9.21594 26.608Z",
    fill: "url(#paint9_linear_3890_386374)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.632 32.064V42.84L27.984 37.448V26.608L18.632 32.064Z",
    fill: "url(#paint10_linear_3890_386374)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6319 32.064L9.21594 26.608V37.448L18.6319 42.84V32.064Z",
    fill: "url(#paint11_linear_3890_386374)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21594 26.608L18.6319 32.064",
    stroke: "#DCDCDC",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.648 54.224L23.2 48.8L32.648 43.336L42.064 48.8L32.648 54.224Z",
    fill: "url(#paint12_linear_3890_386374)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 34.776L32.616 29.384L41.968 34.776L32.616 40.232L23.2 34.776Z",
    fill: "url(#paint13_linear_3890_386374)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.616 40.2239V50.9999L41.968 45.6079V34.7679L32.616 40.2239Z",
    fill: "url(#paint14_linear_3890_386374)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.616 40.2239L23.2 34.7679V45.6079L32.616 50.9999V40.2239Z",
    fill: "url(#paint15_linear_3890_386374)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2 34.776L32.616 40.232",
    stroke: "#DCDCDC",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3890_386374",
    x1: 29.104,
    y1: 38.64,
    x2: 36.176,
    y2: 26.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3890_386374",
    x1: 29.056,
    y1: 24.592,
    x2: 36.096,
    y2: 12.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3890_386374",
    x1: 32.6,
    y1: 26.608,
    x2: 41.968,
    y2: 26.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C8C8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3890_386374",
    x1: 23.232,
    y1: 26.608,
    x2: 32.6,
    y2: 26.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C8C8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3890_386374",
    x1: 43.192,
    y1: 46.752,
    x2: 50.264,
    y2: 34.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3890_386374",
    x1: 45.656,
    y1: 31.864,
    x2: 47.68,
    y2: 21.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3890_386374",
    x1: 46.704,
    y1: 34.728,
    x2: 56.056,
    y2: 34.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3890_386374",
    x1: 37.288,
    y1: 34.728,
    x2: 46.704,
    y2: 34.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3890_386374",
    x1: 15.1119,
    y1: 46.752,
    x2: 22.1839,
    y2: 34.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3890_386374",
    x1: 17.5759,
    y1: 3.08889e-7,
    x2: 19.6079,
    y2: 3.08889e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3890_386374",
    x1: 18.632,
    y1: 0.0000314251,
    x2: 27.976,
    y2: 0.0000314251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3890_386374",
    x1: 9.21594,
    y1: 0.0000315495,
    x2: 18.6319,
    y2: 0.0000315495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3890_386374",
    x1: -0.0000521403,
    y1: 54.912,
    x2: 36.176,
    y2: 42.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3890_386374",
    x1: -0.0000470655,
    y1: 40.872,
    x2: 36.096,
    y2: 28.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3890_386374",
    x1: -0.0000322389,
    y1: 42.8879,
    x2: 0.799968,
    y2: 42.8879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F6F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C8C8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3890_386374",
    x1: -0.0000488281,
    y1: 42.8879,
    x2: 0.799951,
    y2: 42.8879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C8C8C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppinstancesmall);
export default __webpack_public_path__ + "static/media/app instance small.de07a3d606d57d08c47be8882098eced.svg";
export { ForwardRef as ReactComponent };